/* import "./jquery-global.js";
import $ from "jquery"; */
import "bootstrap";
//import { Collapse } from 'bootstrap';


import "./custom.js";

import "./modules/hero-section/hero-section.js";
import "./modules/logo-gallery/logo-gallery.js";
import "./modules/onboarding/onboarding.js";
import "./modules/section-interview/section-interview.js";
import "./modules/thumbnail-gallery/thumbnail-gallery.js";
import "./modules/video-small/video-small.js";
